import React from 'react';
import { Button } from "@/components/ui/button";
import { Eye, Trash2, ExternalLink } from "lucide-react";
import { BookingDetails } from "@/hooks/bookings/types";
interface BookingActionsProps {
  booking: BookingDetails;
  onViewDetails: (booking: BookingDetails) => void;
  onCancelBooking: (bookingId: string) => void;
}
const BookingActions: React.FC<BookingActionsProps> = ({
  booking,
  onViewDetails,
  onCancelBooking
}) => {
  const handleOpenInTab = (e: React.MouseEvent) => {
    e.stopPropagation();
    window.open(`/booking/${booking.id}`, "_blank");
  };

  return (
    <div className="mt-4 flex gap-2 w-full">
      <Button 
        variant="outline" 
        size="sm" 
        onClick={(e) => {
          e.stopPropagation();
          onCancelBooking(booking.id);
        }} 
        disabled={booking.status.toLowerCase() === "cancelled"} 
        title={booking.status.toLowerCase() === "cancelled" ? "Already cancelled" : "Delete booking"} 
        className="flex-1 flex items-center justify-center gap-1"
      >
        <Trash2 className="h-4 w-4" /> Delete
      </Button>
      
      <Button 
        variant="outline" 
        size="sm" 
        onClick={(e) => {
          e.stopPropagation();
          onViewDetails(booking);
        }} 
        className="flex-1 flex items-center justify-center gap-1"
      >
        <Eye className="h-4 w-4" /> View
      </Button>

      <Button 
        variant="outline" 
        size="sm" 
        onClick={handleOpenInTab}
        className="flex-1 flex items-center justify-center gap-1"
      >
        <ExternalLink className="h-4 w-4" /> Open
      </Button>
    </div>
  );
};
export default BookingActions;